import About from "../components/About";
import Home from "../components/Layout/Home";
import Breadcrumbs from "../components/Layout/Breadcrumb";
import Products from "../components/Packages/Product";
import HelpList from "../components/Help/HelpList";
import Help from "../components/Help/Help";
import Channels from "../components/Channels/Channels";
import Contact from "../components/Contact";
import { subUrl } from "./globals";

export const Routing = {
  Public: [
    {
      path: subUrl,
      component: (
        <div className="page-content">
          <Home />
        </div>
      ),
    },
    {
      path: subUrl + "about",
      component: <About />,
    },
    {
      path: subUrl + "helpdesk",
      component: (
        <Breadcrumbs
          title="HELP DESK"
          content={<HelpList language="en" />}
          route={[{ url: subUrl+"helpdesk", text: "Help Desk" }]}
        />
      ),
    },
    {
      path: subUrl + "helpdesk/:id",
      component: <Help />,
    },
    {
      path: subUrl + "channel/:category",
      component: <Channels />,
    },
    {
      path: subUrl + "packages",
      component: (
        <div className="page-content">
          <Products />,
        </div>
      ),
    },
    {
      path: subUrl + "contact",
      component: (
        <Breadcrumbs
          title="CONTACT US"
          content={<Contact />}
          route={[{ url: subUrl + "contact", text: "Contact us" }]}
        />
      ),
    },
  ],

  English: [],
};
